/**
 * Loads the workspace's readiness rules for everyone signed in, whenever the
 * workspace changes: the every-item rules (workspace_definition_policy) and the
 * readiness definitions. Every screen that asks "is this item complete / ready"
 * reads them from the stores, so without this an admin's Settings → Readiness
 * choices applied only in the browser tab where the settings page was open.
 */

import { useEffect } from 'react';
import { useTenantStore } from '../../stores/prioritization/tenantStore';
import { useDefinitionPolicyStore } from '../../stores/prioritization/definitionPolicyStore';
import { useReadinessDefinitionStore } from '../../stores/prioritization/readinessDefinitionStore';

export function ReadinessRulesBootstrap() {
  const workspaceId = useTenantStore((s) => s.currentWorkspaceId);
  const loadEveryItemRules = useDefinitionPolicyStore((s) => s.loadForWorkspace);
  const clearEveryItemRules = useDefinitionPolicyStore((s) => s.clear);
  const loadDefinitions = useReadinessDefinitionStore((s) => s.loadForWorkspace);
  const clearDefinitions = useReadinessDefinitionStore((s) => s.clear);

  useEffect(() => {
    if (!workspaceId) {
      clearEveryItemRules();
      clearDefinitions();
      return;
    }
    void loadEveryItemRules(workspaceId);
    void loadDefinitions(workspaceId);
  }, [workspaceId, loadEveryItemRules, clearEveryItemRules, loadDefinitions, clearDefinitions]);

  return null;
}
